import PropTypes from 'prop-types';
import { Component } from 'react';
import { isEqual } from 'lodash';

class JobsWrapper extends Component {
	componentDidMountAddOn = () => {
		const { processUrl } = this.props;
		processUrl(true);
	}

	UNSAFE_componentWillReceivePropsAddOn = ({ match : { params }, location, processUrl }) => {
		const lastProps = this.props;
		const reloadCounters = (
			!isEqual(location.search, lastProps.location.search)
			|| !isEqual(location.query, lastProps.location.query)
		);

		/**
		 * processUrl when the query param
		 * has changed, or the viewType has
		 * also changed
		 */
		if (
			!isEqual(params.viewType, lastProps.match.params.viewType)
			|| !isEqual(location.search, lastProps.location.search)
			|| !isEqual(location.query, lastProps.location.query)
		) processUrl(reloadCounters);
	}
}

JobsWrapper.propTypes = {
	processUrl : PropTypes.func.isRequired,
	location   : PropTypes.object.isRequired,
	match      : PropTypes.object.isRequired,
};

export default JobsWrapper;
